import React from "react";
import PersistentHomeHero from "./PersistentHomeHero";

export function wrapPageElement({ element, props }) {
  return (
    <>
      <PersistentHomeHero location={props.location} />
      {element}
    </>
  );
}
